import _axios from "../../platform";
import qs from 'qs'

// 获取广告位
export const getAdBannerApi = params =>
    _axios({
        url: "/content-plus/api/adBanner/getRechargeAdBanner",
        method: "get",
        params
    });